import { STATUS_CREATED, STATUS_CREATED_CODE, } from '../constants/constant';
import { ADD_CHILDREN_KEY, EMPTY_CHILDREN_KEY, mainFormKey } from "./interface";

interface RowKeyProps {
  mainKey?: string;
  childrenKey?: string;
};
interface ChangeKeyProps {
  mainKey?: string;
  childrenKey?: string;
  name?: string;
  value?: any;
};
export function formatRowKey(rowKey?: string): RowKeyProps {
  const rowKeys: RowKeyProps = {};
  if (!rowKey) return rowKeys;
  const keyArr = rowKey.split('-');
  rowKeys.mainKey = keyArr[0];
  rowKeys.childrenKey = keyArr[1] ?? mainFormKey;
  return rowKeys;
}
/**
 * 转换当前表单的name
 * @param rowKey 当前行key
 * @param name 字段名称
 * @returns 
 */
export function formatFormName(rowKey: any, name: any) {
  const key = formatRowKey(rowKey);
  if (!name) return;
  if (Array.isArray(name)) {
    return name.map(item => {
      return [key.mainKey, key.childrenKey, item];
    });
  }
  return [key.mainKey, key.childrenKey, name];
}
/**
 * 转换当前表单名称字段
 * @param changeInfo 
 * @returns 
 */
export function formatChangeInfo(changeInfo: any): ChangeKeyProps {
  const changeKeys: ChangeKeyProps = {};
  const [mainKey, mainValue] = getFileNameInfo(changeInfo);
  changeKeys.mainKey = mainKey;
  if (mainValue) {
    const [childrenKey, childrenValue] = getFileNameInfo(mainValue);
    changeKeys.childrenKey = childrenKey;
    if (childrenValue) {
      const [itemKey, itemValue] = getFileNameInfo(childrenValue);
      changeKeys.name = itemKey;
      changeKeys.value = itemValue;
    }
  }
  return changeKeys;
}
export function getFileNameInfo(fileNameInfo: any): any[] {
  if (!fileNameInfo) return [];
  return [Object.keys(fileNameInfo)[0], Object.values(fileNameInfo)[0]];
}
export function getEffectiveChildren(childrenData: any) {
  let effectiveChildren: any[] = [];
  if (Array.isArray(childrenData) && childrenData.length) {
    effectiveChildren = childrenData.filter(v => !(v?.[ADD_CHILDREN_KEY] || v?.[EMPTY_CHILDREN_KEY]));
  }
  return effectiveChildren;
}
/**
 * 过滤已删除数据
 * @param dataSource 
 * @param hiddenAddSubRow 
 * @returns 
 */
export function filterDeleteData(
  dataSource?: any[],
  hiddenAddSubRow?: (mainData: any) => boolean,
): any[] {
  const effectiveDataSource: any[] = [];
  if (Array.isArray(dataSource) && dataSource.length) {
    dataSource.forEach(item => {
      if (item[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE) {
        const children = item.children;
        let effectiveChildren: any[] = []
        const hiddenAdd = hiddenAddSubRow ? hiddenAddSubRow(item): false;
        if (Array.isArray(children)) {
          children.forEach(child => {
            if (child[ADD_CHILDREN_KEY]) {
              !hiddenAdd && effectiveChildren.push(child);
              return;
            }
            if (child[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE) {
              effectiveChildren.push(child);
            }
          });
        }
        effectiveDataSource.push({
          ...item,
          children: effectiveChildren,
        });
      }
    });
  }
  return effectiveDataSource;
}
